<template>
  <div class="mt-5">
    <div class="container">
      <div v-if="hasSession" class="col-12 d-flex justify-center align-items-center">
        <div class="flex-none font-weight-bold" v-if="isLoading">
          <i class="fa fa-spinner fa-3x mr-3"></i>
          Completing Email Address Change...
        </div>
        <div v-show="error" class="flex-none">
          <i class="fa fa-exclamation-triangle fa-3x mr-3 text-danger"></i>
        </div>
        <div v-show="error" class="font-weight-bold flex-none">
          {{ error }}
          <div v-show="!emailChangeStatus" class="col-md-8 py-3">
            Click the profile button below if you want to change your email again.
            <router-link :to="{ name: 'ProfileShow'}" replace
                         class="btn btn-tertiary btn-block mt-3">View Profile</router-link>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="col-12 d-flex justify-center align-items-center">
          <div class="flex-none">
            <i class="fa fa-exclamation-triangle fa-3x mr-3 text-warning"></i>
          </div>
          <div class="font-weight-bold flex-none">
            You are not logged in. You must be logged in to complete changing your account email.
            <div class="col-md-8 py-3">
              Click the login button below to Login and complete your account email change.
              <router-link :to="{ name: 'Login', query: { redirect: this.$route.fullPath } }"
                           class="btn btn-tertiary btn-block mt-2">Login
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {mapGetters, mapActions} from 'vuex';

export default {
  name: "ChangeEmail",
  data() {
    return {}
  },
  created() {
    // Use the JWT to initiate the email change/revert
    let jwt = decodeURIComponent(this.$route.params.token)
    this.changeEmail(jwt)
  },
  watch: {
    emailChangeStatus(newVal) {
      if (newVal) {
        // Navigate to the profile page
        this.$router.replace({name: 'ProfileShow'})
      }
    }
  },
  computed: {
    ...mapGetters({
      hasSession: "user/profile/hasSession",
      isLoading: "user/change_email/isLoading",
      error: "user/change_email/error",
      emailChangeStatus: "user/change_email/emailChangeStatus",
    }),
  },
  methods: {
    ...mapActions({
      changeEmail: "user/change_email/change",
    }),
  }
}
</script>

<style lang="scss" scoped>
</style>
